import React from 'react';
import c from 'classnames';
import isNumber from 'lodash/isNumber';

import { useTranslation } from '@lyearn/i18n';
import { FileCompletePlaceholder } from '@lyearn/icons';
import { Box, LinearProgress, Loader, Typography } from '@lyearn/ui';

import { cardPadding } from './style';
import { UploadCardProps } from './types';

function UploadCard(props: UploadCardProps) {
  const {
    name,
    type,
    size,
    isUploading,
    progress,
    isProcessing,
    processingProgress,
    PlaceholderIcon = FileCompletePlaceholder,
    isUploadingExternally,
  } = props;
  const { t } = useTranslation();

  if (isUploadingExternally) {
    return (
      <Box
        className={c(
          'flex mx-auto items-center justify-center rounded-8 border border-border bg-bg-secondary p-16',
          cardPadding,
        )}
        style={{ width: 600, height: 400 }}>
        <Loader className="text-text-primary" size={28} thickness={2} />
      </Box>
    );
  }

  return (
    <Box
      className={c(
        'flex w-full items-center rounded-8 border border-border bg-bg-secondary',
        cardPadding,
      )}>
      <Box className="flex items-center">
        <PlaceholderIcon width={28} />
      </Box>
      <Box className="flex h-38 w-full flex-col ps-12">
        <Box className="flex h-22 xs:pe-40">
          <Typography className="w-full truncate text-text-primary" variant="body-short-02">
            {name}
          </Typography>
          {isUploading ? (
            <Typography className="w-full text-text-placeholder text-end" variant="heading-xxs">
              {progress}%
            </Typography>
          ) : null}
          {isProcessing && isNumber(processingProgress) ? (
            <Typography className="w-full text-right text-text-placeholder" variant="heading-xxs">
              {processingProgress}%
            </Typography>
          ) : null}
        </Box>
        <Box className="flex h-16 items-center">
          {isUploading ? (
            <LinearProgress className="w-full" color="success" value={progress} />
          ) : isProcessing ? (
            <Typography className="text-text-secondary" variant="body-short-03">
              {t('Common:BulkImport.Processing')}
            </Typography>
          ) : (
            <Typography className="text-text-secondary" variant="body-short-03">
              {type?.toUpperCase()}
              &ensp;&bull; &ensp;
              {size?.toUpperCase()}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default UploadCard;
